import React, { useEffect, useState } from "react";
import Header from "../../../components/header/Header";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Container,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  Select,
  Tab,
  TextField,
  TextareaAutosize,
  Typography,
} from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
// import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import deleteRow from "../../../../assets/images/delete.png";
// import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import RichTextEditorFull from "../../../../components/Course/RichTextEditor/RichTextEditorFull";
// import { MenuItem } from "react-pro-sidebar";
// import { DataGrid } from "@mui/x-data-grid";
// import CircularProgress from "@mui/material/CircularProgress";
// import searchIcon from "../../../../assets/images/SearchIcon.png";
// import searchIconFilter from "../../../../assets/images/searchIconFilter.png";
// import ReusableDialog from "../../../../components/reusableDialog/ReusableDialog";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useParams } from "react-router-dom";
// import { defaultCategoryDetails } from "./constant";
// import {
//   addCategoryService,
//   updateCategoryService,
// } from "../../../../utils/services/course/category/categoryService";
import { useDispatch, useSelector } from "react-redux";
import GeneralDetails from "./GeneralDetails";
import ResourceView from "./resources-view/ResourceView";
import Quiz from "./quiz-form/QuizQuestions";
import QuizView from "./quiz-view/QuizView";
import { useContext } from "react";
import RouteContext from "../../../utils/context/RouteContext";
// import {
//   getParticularCourseOfCategory,
//   searchCourseKeyChanged,
// } from "./categorySlice";
const SessionDetails = () => {
  //   const { searchCourseKey } = useSelector((state) => state?.category);

  const navigate = useNavigate();
  const [params] = useSearchParams();
  // const formType = params.get("formType");
  const dispatch = useDispatch();

  //   const handleNavigate = () => {
  //     navigate("/courses/course-categories");
  //   };

  const {
    state: {
      data,
      tabValue,
      batchName,
      batchId,
      courseName,
      courseId,
      formType,
    },
  } = useLocation();
  const access = JSON.parse(localStorage.getItem("level"));
  const levelPermission = access?.Batch?.write;
  const { role } = useContext(RouteContext);

  console.log("sessssssssssssss", formType);

  const handleBatchoverviewNavigate = ({ courseId, courseName }) => {
    navigate(`/batch/batchesoverview/${courseId}/${courseName}`);
  };

  const handleBatchNavigation = () => {
    if (formType === "edit-self-batch") {
      navigate(`/batch/batchesoverview/add-self-batch?formType=${formType}`, {
        state: {
          courseId,
          courseName,
          batchId,
          batchName,
          formType,
        },
      });
    } else {
      navigate(`/batch/batchesoverview/add-batch?formType=${formType}`, {
        state: {
          courseId,
          courseName,
          batchId,
          batchName,
          formType,
        },
      });
    }
  };

  //   const [categoryDetails, setCategoryDetails] = useState(
  //     formType === "edit" ? data : defaultCategoryDetails
  //   );
  const [preRequisites, setPreRequisites] = useState(
    formType === "edit" ? data?.preRequisites : ""
  );
  const [isLoading, setIsLoading] = useState(false);

  const [questionData, setQuestionData] = useState(
    formType === "edit"
      ? data?.faqs
      : [
          {
            question: "",
            answer: "",
          },
        ]
  );

  const [expanded, setExpanded] = useState("panel1");
  const [expanded2, setExpanded2] = useState("panel2");
  const [expanded3, setExpanded3] = useState("panel3");

  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [rowId, setRowId] = useState();

  const handleChangeopen = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  const handleChangeopen2 = (panel) => (event, newExpanded) => {
    setExpanded2(newExpanded ? panel : false);
  };
  const handleChangeopen3 = (panel) => (event, newExpanded) => {
    setExpanded3(newExpanded ? panel : false);
  };

  const handleSave = () => {
    setValue("2");
  };

  const [QuestionArray, setQuestionArray] = useState([{}]);

  const [value, setValue] = React.useState("1");
  const [timeZoneValue, setTimeZoneValue] = useState("Mumbai");

  useEffect(() => {
    if (tabValue != undefined) {
      setValue(tabValue);
    }
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleSelectChange = (event) => {
    setTimeZoneValue(event.target.value);
  };

  return (
    <>
      <div
        // style={{
        //   backgroundColor: "#F7F7F7",
        //   display: "flex",
        //   flexDirection: "column",
        // }}
        className="content-container"
      >
        <Header />
        {/* <Container
          maxWidth="mb"
          style={{
            backgroundColor: "#f7f7f7",
            height: "75vh",
          }}
        > */}
        <div
          className="header-title"
          style={{
            backgroundColor: "white",
            paddingLeft: "4%",
            paddingRight: "4%",
          }}
        >
          <Typography>
            <span
              style={{ color: "#8C8C8C", cursor: "pointer" }}
              onClick={() => navigate("/batch")}
            >
              Course List /
            </span>
            <span
              style={{ color: "#8C8C8C", cursor: "pointer" }}
              onClick={() =>
                handleBatchoverviewNavigate({ courseName, courseId })
              }
            >
              {courseName} /
            </span>
            <span
              style={{ color: "#8C8C8C", cursor: "pointer" }}
              onClick={() => handleBatchNavigation()}
            >
              {batchName} /
            </span>
            <span>{data?.sessionName}</span>
          </Typography>
          <p
            style={{
              padding: "1rem 0rem",
              fontSize: "1.5rem",
              fontWeight: "500",
            }}
          >
            {data?.sessionName}
          </p>
        </div>
        <Box sx={{ width: "100%", typography: "body1" }}>
          <TabContext value={value}>
            <Box>
              <TabList
                onChange={handleChange}
                sx={{
                  backgroundColor: "white",
                  paddingLeft: "4%",
                }}
                TabIndicatorProps={{
                  style: { backgroundColor: "black" }, // Change the background color to your desired color
                }}
                // indicatorColor="primary"
              >
                {formType !== "edit-self-batch" && (
                  <Tab
                    label="Session Details"
                    inkBarStyle={{ background: "black" }}
                    value={formType === "edit-self-batch" ? "-1" : "1"}
                    sx={{
                      textTransform: "none",
                      color: (theme) =>
                        theme.palette.mode === "dark" ? "#000000" : "#B3B3B3",
                      "&.Mui-selected": {
                        color: "#000000",
                        fontWeight: 600,
                      },
                      marginRight: "1rem",
                      fontWeight: 500, // Add a right margin to create a gap between tabs
                      borderBottom: "none", // Remove the bottom line
                    }}
                  />
                )}
                <Tab
                  label="Resources and References"
                  value={formType === "edit-self-batch" ? "1" : "2"}
                  sx={{
                    textTransform: "none",

                    color: (theme) =>
                      theme.palette.mode === "dark" ? "#000000" : "#B3B3B3",
                    "&.Mui-selected": {
                      color: "#000000",
                      fontWeight: 600,
                      borderBottom: "none",
                    },
                    marginRight: "1rem",
                    fontWeight: 500, // Add a right margin to create a gap between tabs
                    borderBottom: "none", // Remove the bottom line
                  }}
                />
                <Tab
                  label="Quiz "
                  value={formType === "edit-self-batch" ? "2" : "3"}
                  sx={{
                    textTransform: "none",
                    color: (theme) =>
                      theme.palette.mode === "dark" ? "#000000" : "#B3B3B3",
                    "&.Mui-selected": {
                      color: "#000000",
                      fontWeight: 600,
                    },
                    marginRight: "1rem",
                    fontWeight: 500, // Add a right margin to create a gap between tabs
                    borderBottom: "none", // Remove the bottom line
                  }}
                />
              </TabList>
            </Box>
            <TabPanel
              value={formType === "edit-self-batch" ? "-1" : "1"}
              sx={{ marginLeft: "3%", marginRight: "3%" }}
            >
              {/* first accordion */}
              <Accordion
                expanded={expanded === "panel1"}
                onChange={handleChangeopen("panel1")}
                sx={{
                  boxShadow: "none",
                  padding: "2rem",
                  borderRadius: ".5rem",
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  sx={{ padding: "0px", borderRadius: "1rem" }}
                >
                  <div
                    className="head-tag "
                    style={{
                      display: "flex",
                      gap: "1rem",
                      justifyContent: "space-between",
                    }}
                  >
                    <div className="number-icon">
                      <b>1</b>
                    </div>
                    <div className="text">
                      <p style={{ fontWeight: "600", color: "#4D4D4D" }}>
                        General Details
                      </p>
                    </div>
                  </div>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: "0px" }}>
                  <div className="from-contaner">
                    {/* <Grid container spacing={2} sx={{ paddingRight: "30%" }}>
                      <Grid item xs={6}>
                        <TextField
                          size="small"
                          fullWidth
                        //   value={categoryDetails.name}
                          placeholder="Session Name"

                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          size="small"
                          fullWidth
                        //   value={categoryDetails.name}
                          placeholder="Session Duration in hrs"

                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          size="small"
                          fullWidth
                        //   value={categoryDetails.name}
                          placeholder="Start Time"

                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          size="small"
                          fullWidth
                        //   value={categoryDetails.name}
                          placeholder="End Time"

                        />
                      </Grid>

                      <Grid item xs={12}>
                        <TextField
                          size="small"
                          multiline
                          minRows={4}
                          fullWidth
                        //   value={categoryDetails.description}
                          placeholder="Session Information"
                        />
                      </Grid>
                    </Grid> */}
                    <GeneralDetails sessionGeneralDetail={data} />
                  </div>
                </AccordionDetails>
              </Accordion>
            </TabPanel>
            <TabPanel
              value={formType === "edit-self-batch" ? "1" : "2"}
              sx={{ marginLeft: "3%", marginRight: "3%" }}
            >
              <div className="from-contaner">
                <ResourceView
                  sessionId={data?.id}
                  role={role}
                  levelPermission={levelPermission}
                  formType={formType}
                />
              </div>
            </TabPanel>
            <TabPanel value={formType === "edit-self-batch" ? "2" : "3"}>
              {/* <Quiz sessionId={data?.id} /> */}
              <QuizView
                sessionId={data?.id}
                role={role}
                levelPermission={levelPermission}
                batchName={batchName}
                courseName={courseName}
                sessionName={data?.sessionName}
                courseId={courseId}
                batchId={batchId}
                dataForPrePath={data}
                batchType={formType}
              />
            </TabPanel>
          </TabContext>
        </Box>
        {/* </Container> */}
      </div>
    </>
  );
};

export default SessionDetails;
